import MarkdownText from './MarkdownText';

  const renderEnhancedAnalysis = (data) => (
    <div className="enhanced-analysis">
      <div className="analysis-header bg-gradient-to-r from-primary/20 to-accent/20 p-6 rounded-lg border border-primary/30 mb-6">
        <h3 className="text-xl font-bold text-primary mb-2 flex items-center">
          🤖 Enhanced AI Analysis
        </h3>
        <div className="analysis-content text-foreground leading-relaxed">
          <MarkdownText>{data.analysis}</MarkdownText>
        </div>
      </div>

      {data.insights && data.insights.length > 0 && (
        <div className="insights-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          {data.insights.map((insight, index) => (
            <div key={index} className="insight-card bg-card p-4 rounded-lg border border-border shadow-sm">
              <div className="flex items-center justify-between mb-2">
                <span className="insight-type text-sm font-medium text-muted-foreground capitalize">
                  {insight.type.replace('_', ' ')}
                </span>
                {insight.trend && (
                  <span className={`trend-indicator px-2 py-1 text-xs rounded-full ${
                    insight.trend === 'improving' ? 'bg-green-500/20 text-green-500' :
                    insight.trend === 'declining' ? 'bg-destructive/20 text-destructive' :
                    'bg-muted text-muted-foreground'
                  }`}>
                    {insight.trend === 'improving' ? '📈 Improving' :
                     insight.trend === 'declining' ? '📉 Declining' :
                     '➡️ Stable'}
                  </span>
                )}
              </div>
              <div className="insight-value text-2xl font-bold text-foreground mb-1">
                {insight.value}
              </div>
              <div className="insight-description text-sm text-muted-foreground">
                {insight.description}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  export default renderEnhancedAnalysis;